<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26 22.5V11a7 7 0 00-7-7h-6.5a1 1 0 00-2 0H8a2 2 0 00-2 2v5a2 2 0 002 2h2.5a1 1 0 002 0H16a1 1 0 011 1v8.5a1 1 0 000 2V27a2 2 0 002 2h5a2 2 0 002-2v-2.5a1 1 0 000-2zM8 11V6h2.5v5zm8 0h-3.5V6H19a5 5 0 015 5v11.5h-5V14a3 3 0 00-3-3zm8 16h-5v-2.5h5z"/></svg>